import { FC } from 'react'
import styled from 'styled-components'
import { Form as AntdForm, FormInstance } from 'antd'
import { AdlSectionExtended } from '@lmc/ts-common'
import { CarePlanSection } from './CarePlanSection'

type Props = {
  sections?: AdlSectionExtended[]
  form?: FormInstance<unknown>
  submitForm?: () => void
  initialValues?: Record<string, string>
  isViewMode?: boolean
}

export const CarePlanSectionContainer: FC<Props> = ({
  sections,
  submitForm,
  initialValues,
  isViewMode,
  form
}) => {
  return (
    <Wrapper>
      <AntdForm
        name="register"
        onFinish={submitForm}
        initialValues={initialValues}
        form={form}
      >
        {sections?.map((section) => {
          if (isViewMode && !section.value) {
            return null
          }

          return (
            <CarePlanSection
              section={section}
              key={
                // By making the key reactive to the value,
                // it will re-mount after changes are saved.
                isViewMode
                  ? `${section?.key}-${section.value ?? ''}`
                  : section?.key
              }
              isViewMode={isViewMode}
              value={section.value}
            />
          )
        })}
      </AntdForm>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  margin-top: 14px;
`
